import React from 'react'
import { Row, Col, Container } from 'reactstrap';
import "./Formularios.scss"

type FormularioValores = {
    titulo: string,
    subtitulo?: Array<FormularioValores>
    formularios?: Array<{ nombre: string, url: string }>
}
const Formularios: React.FC = () => {
    const TITULO_SITIO_FORMULARIOS = "Formularios"
    const array_formularios: Array<FormularioValores> = [
        //{
        //    titulo: "ACUERDO DE RESPONSABILIDAD Y USO DE MEDIOS ELECTRÓNICOS",
        //    formularios: [
        //        {
        //            nombre: "Acuerdo de Uso de medios electrónicos",
        //            url: "https://talentohumano.espol.edu.ec/Sitio/archivos/Formato-Acuerdo-Responsabilidad-Uso-Medios-Electronicos-ESPOL.docx"
        //        }
        //    ]
        //},
        // {
        //     titulo: "NEPOTISMO",
        //     subtitulo: [
        //         {
        //             titulo: "Régimen Laboral: 1. LOES (Personal Académico y Personal de Apoyo Académico), 2. CÓDIGO CIVIL - LOES (Profesor Invitado, Honorario y Emérito)",
        //             formularios: [
        //                 {
        //                     nombre: "Declaración de NO Vinculación con Máximas Autoridades y Miembros de los Cuerpos Colegiados para el Personal Académico y Personal de Apoyo Académico Previo a ser Planificado",
        //                     url: "https://talentohumano.espol.edu.ec/Sitio/archivos/formulario_declaracion_vinculacion_maximas_autoridades_2021117.xlsx"
        //                 },
        //                 {
        //                     nombre: "Declaración Juramentada de NO Encontrarse Incurso en Nepotismo con las Máximas Autoridades de la ESPOL Personal Docente (personal académico y personal de apoyo académico)",
        //                     url: "https://talentohumano.espol.edu.ec/Sitio/archivos/DECLARACION_JURAMENTADA_NO_ENCONTRARSE_INCURSO_NEPOTISMO_MAXIMAS_AUTORIDADES_ESPOL_PERSONAL_DOCENTE_20211116.docx"
        //                 }
        //             ]
        //         },
        //         {
        //             titulo: "Régimen Laboral: 1. LOSEP, 2. CÓDIGO DE TRABAJO, 3. CÓDIGO CIVIL (Servicios profesionales, servicios técnicos especializados).",
        //             formularios: [
        //                 {
        //                     nombre: "Declaración Juramentada de NO Encontrarse Incurso en Nepotismo con las Máximas Autoridades de la ESPOL Personal NO Docente (personal no docente)",
        //                     url: "https://talentohumano.espol.edu.ec/Sitio/archivos/DECLARACION_JURAMENTADA_NO_ENCONTRARSE_INCURSO_NEPOTISMO_MAXIMAS_AUTORIDADES_ESPOL_PERSONAL_NO_DOCENTE_20211116.docx"
        //                 }
        //             ]
        //         }
        //     ]
        // },
        //{
        //    titulo: "PARA REGISTRO O CAMBIO DE CUENTA BANCARIA",
        //    formularios: [
        //        {
        //            nombre: "Formulario de Solicitud de Registro o Cambio de Cuenta Bancaria",
        //            url: "https://www.serviciosti.espol.edu.ec/formularios/FORMULARIO-DE-SOLICITUD-DE-REGISTRO-NUEVO-O-CAMBIO-CUENTA%20BANCARIA-2019_A.xlsx"
        //        },
        //    ]
        //},
        {
            titulo: "PERMISOS, LICENCIAS Y VACACIONES",
            formularios: [
                // {
                //     nombre: "Formulario de Solicitud de Permiso o Licencia",
                //     url: "https://serviciosti.espol.edu.ec/formularios/FT-01-V02 PRO-DHO-012 FORMULARIO DE PERMISOS-14-04-2023.xlsx"
                // },
                // {
                //     nombre: "Formulario de Solicitud de Vacaciones",
                //     url: "https://serviciosti.espol.edu.ec/formularios/FORMULARIO-DE-SOLICITUD-DE-VACACIONES-2023-05-12.pdf"
                // },
                // {
                //     nombre: "Formulario de Solicitud de Permiso imputable a Vacaciones",
                //     url: "https://serviciosti.espol.edu.ec/formularios/FORMULARIO-DE-SOLICITUD-DE-PERMISO-IMPUTABLE-VACACIONES-2023-09-21.pdf"
                // },
                // {
                //     nombre: "Formulario de Solicitud de Reintegro de Vacaciones",
                //     url: "https://serviciosti.espol.edu.ec/formularios/FORMULARIO-DE-SOLICITUD-DE-REINTEGRO-VACACIONES-2023-05-12.pdf"
                // }
                {
                    nombre:"Formulario de Solicitud de Permiso, Licencia y Comisión",
                    url: "https://www.serviciosti.espol.edu.ec/formularios/FORMULARIO-DE-SOLICITUD-DE-PERMISO-LICENCIA-COMISION-202309.pdf"
                }
            ]
        },
        {
            titulo: "PAGOS DE HORAS EXTRAS",
            formularios: [
                {
                    nombre: "Formulario de Solicitud de Pago de Horas Extras",
                    url: "https://www.serviciosti.espol.edu.ec/formularios/FORMULARIO-DE-SOLICITUD-DE-PAGO-DE-HORAS-EXTRAS-202411.xlsx"
                }
            ]
        },
        {
            titulo: "TRANSFERENCIAS AL EXTERIOR",
            formularios: [
                {
                    nombre: "Formulario de Solicitud de Transferencias al exterior",
                    url: "https://talentohumano.espol.edu.ec/Sitio/archivos/FORMULARIO-GIROS-AL-EXTERIOR.pdf"
                }
            ]
        },
        {
            titulo: "FORMATOS DE INFORMES",
            formularios: [
                {
                    nombre: "Formato de Informe de Actividades para Pago de Contratos por Servicios Profesionales",
                    url: "https://talentohumano.espol.edu.ec/Sitio/archivos/FORMATO-INFORME-ACTIVIDADES-PAGO-CONTRATOS-SERVICIOS-PROFESIONALES.docx"
                },
                {
                    nombre: "Formato de Informe de Fin de Gestión para servidores (personal administrativo y docente)",
                    url: "https://talentohumano.espol.edu.ec/Sitio/archivos/FT-03-V02_FORMATO_INFORME_FIN_GESTION_SERVIDORES.docx"
                },
                {
                    nombre: "Formato de Informe de Fin de Gestión para directivos",
                    url: "https://talentohumano.espol.edu.ec/Sitio/archivos/FT-04-V02_FORMATO_INFORME_FINAL_GESTION_DIRECTIVOS.docx"
                },
                {
                    nombre: "Formato de Informe para Asesores",
                    url: "https://talentohumano.espol.edu.ec/Sitio/archivos/FORMATO-INFORME-ASESORES.docx"
                }
            ]
        }
        //,
        //{
        //    titulo: "FORMATO DE JUSTIFICACIÓN DE JORNADA LABORAL",
        //    formularios: [
        //        {
        //            nombre: "Solicitud de recuperación de tiempo no laborado - Jornada Laboral",
        //            url: "https://talentohumano.espol.edu.ec/Sitio/archivos/FT-01-V01%20PRO-DHO-032%20Solicitud_de_recuperacion_de_tiempo_no_laborado_1.pdf"
        //        },
        //        {
        //            nombre: "Solicitud de Justificación de marcación - Jornada Laboral",
        //            url: "https://talentohumano.espol.edu.ec/Sitio/archivos/FT-02-V01%20PRO-DHO-032%20Solicitud_de_Justificacion_de_marcacion_1.pdf"
        //        },
        //    ]
        //}
    ]

    const devolver_formularios = (array_formularios: Array<FormularioValores>) => {
        const seccion_formularios = array_formularios.map((valores, index) => {
            return (
                <div className="parent_formulario_no_login">
                    <div className={"seccion_titulo"}>
                        <div>{valores.titulo}</div>
                        {
                            valores.subtitulo !== undefined && valores.subtitulo.map((subtitulo => {
                                return (
                                    <React.Fragment>
                                        <div className="seccion_subtitulo" >
                                            {subtitulo.titulo}
                                        </div>

                                        <div className="seccion_enlaces">
                                            {subtitulo.formularios !== undefined && subtitulo.formularios.map(f => {
                                                return (
                                                    <div className="enlaces">
                                                        <a href={f.url} rel="noopener noreferrer" target="_blank">
                                                            <span>{f.nombre}</span>
                                                        </a>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </React.Fragment>

                                )
                            }))
                        }
                        {
                            valores.formularios !== undefined && valores.formularios.map((f) => {
                                return (
                                    <div className="enlaces">
                                        <a className="enlaces" href={f.url} rel="noopener noreferrer" target="_blank">
                                            <span>{f.nombre}</span>
                                        </a>
                                    </div>
                                )
                            })
                        }
                    </div>

                </div>
            )
        })
        return seccion_formularios;
    }

    return (
        <div>

            <div className="container_formularios_nologin">
                <Container fluid={true}>
                    <Row className="justify-content-center" >
                        <Col xl={8}>
                            <h4>{TITULO_SITIO_FORMULARIOS}</h4>
                        </Col>
                    </Row>
                    <Row className="justify-content-center">

                        <Col xl={8} lg={10} md={12}>

                            {devolver_formularios(array_formularios)}

                        </Col>

                    </Row>
                </Container>
            </div>
        </div>
    )
}
export default Formularios